import React, { FormEvent, useContext, useEffect } from "react";
import { useState } from "react";
import { Grid,Tab,Form,Input,Select,Button,Table, List, Image, Segment, TextArea, Message} from "semantic-ui-react";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { observer } from "mobx-react-lite";
import MobileStore from "../../../app/stores/mobileStore";
import TextareaAutosize from "react-textarea-autosize";
import { Link } from "react-router-dom";
import { IAssign } from "../../../app/models/assign";

const MobileAssignmentTab = () => {
  const mobileStore = useContext(MobileStore);
  const {
    project,
    assign,
    TechzoneByName,
    TechWorkByName,
    TechGPSByName,
    TechACByName,
    techinductionRegistry,
    searchTechnician,
    AssignTechnicians,
    loadMobileAssignments,
    createMobileAssignment,
    target,
  } = mobileStore;

  const [term, setTerm] = useState("");
  const [assignment, setAssignment] = useState<IAssign[]>([
  {
    item: "TechWork",
    manday: "0",
    remark: "",
  },
  {
    item: "GPS",
    manday: "0",
    remark: "",
  },
  {
    item: "AC",
    manday: "0",
    remark: "",
  }]);

  const [total, setTotal] = useState(0);

  useEffect(() => {
    // loadMobileAssignments(project!.id).then(
    //   (assign) => {setAssignment(assign); 
    //     setTotal(Number(assign[0].manday) + Number(assign[1].manday) + Number(assign[2].manday));});
    if (assign !== null) 
    {
      const newassign = assign.map(object => ({ ...object }));
      setAssignment(newassign); 
       setTotal(Number(newassign[0].manday) + Number(newassign[1].manday) + Number(newassign[2].manday));
    }
  }, []);

  


  function onDragEnd(result: any) {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    const sInd = source.droppableId;
    const dInd = destination.droppableId;
    const email = result.draggableId.split("+")[0];

    if (sInd !== dInd) {
      AssignTechnicians(sInd, dInd, email);
    }
  }

  const handleSearch=(event: FormEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    setTerm(value);
    searchTechnician(value);
  }

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, index: number, name: keyof IAssign
  ) => {
    let newArr = [...assignment]; // copying the old datas array
    newArr[index][name] = event.currentTarget.value; // replace e.target.value with whatever you want to change it to
    setAssignment(newArr);
    setTotal(Number(assignment[0].manday) + Number(assignment[1].manday) + Number(assignment[2].manday))
  }

  return (
    <Tab.Pane>
      <Input  type="text" focus icon="search" placeholder="Search employee" onChange={handleSearch} value={term}/>
      <DragDropContext
        onDragEnd={onDragEnd}
      >
        <Droppable droppableId="TechZone">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={{ backgroundColor: snapshot.isDraggingOver ? 'grey' : 'transparent' }}
              {...provided.droppableProps}
            >
              {TechzoneByName.map((tech, index) => (
              <Draggable key={tech.email} draggableId={tech.email+"+TechZone"} index={index}>
                {(provided, snapshot) => (
                  <List horizontal>       
              <List.Item >
              <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
               <Button as={Link} basic compact
                 to={`/hrmanagement/employees/${tech.email}`}
               >
               <Image avatar src={tech.photoUrl || "/assets/user.png"}/>
                <strong style={(tech.status === 'Employee') ? {color: 'green'} : {color: 'brown'}}>
                  {tech.name}{tech.preferredName !== "" ? `  (${tech.preferredName})` : ""}</strong>
              </Button>
                </div>
              </List.Item>
                     </List>
                )}
              </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      
      <Table celled compact definition>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell textAlign='center' width={3}>Item</Table.HeaderCell>
        <Table.HeaderCell textAlign='center' width={2}>Man-days</Table.HeaderCell>
        <Table.HeaderCell textAlign='center' width={5}>Technician</Table.HeaderCell>
        <Table.HeaderCell textAlign='center' width={6}>Remark</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      <Table.Row>
        <Table.Cell textAlign='center'>
          <strong>Tech Work</strong>
        </Table.Cell>
        <Table.Cell textAlign='center'>
          <Input
            transparent
            onChange={(e)=>handleInputChange(e, 0, "manday")}
            type='number'
            value={assignment[0].manday}
            style={{width: '4rem'}}
          />
        </Table.Cell>
        <Table.Cell>
        <Droppable droppableId="TechWork">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={{ backgroundColor: snapshot.isDraggingOver ? 'grey' : 'transparent', minHeight: "70px" }}
              {...provided.droppableProps}
            >
              {TechWorkByName.map((tech, index) => (
              <Draggable draggableId={tech.email+"+TechWork"} index={index}>
                {(provided, snapshot) => (
                  <List>
              <List.Item>
              <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
               <Button as={Link} basic compact
                 to={`/hrmanagement/employees/${tech.email}`}
               >
               <Image avatar src={tech.photoUrl || "/assets/user.png"}/>
                <strong style={(tech.status === 'Employee') ? {color: 'green'} : {color: 'brown'}}>
                  {tech.name}{tech.preferredName !== "" ? `  (${tech.preferredName})` : ""}</strong>
              </Button>
              {(techinductionRegistry.get(tech.email) === 'N') ? 
              <Message negative size='mini' compact style={{padding: '0em 0.5em'}}>
                Not Inducted</Message> : ''}
                </div>
              </List.Item>
                     </List>
                )}
              </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        </Table.Cell>
        
        <Table.Cell>
         <Form>
          {/* <TextArea 
           rows={2}
           onChange={(e)=>handleInputChange(e, 0, "remark")}
           value={assignment[0].remark}
          /> */}
          <Form.Field
          control={TextareaAutosize}
          rows={1}
          onChange={(e: any)=>handleInputChange(e, 0, "remark")}
          value={assignment[0].remark}
        />
         </Form>
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell textAlign='center'><strong>GPS Cabling/Antenna</strong></Table.Cell>
        <Table.Cell textAlign='center'>
          <Input
            transparent
            onChange={(e, name)=>handleInputChange(e, 1, "manday")}
            type='number'
            value={assignment[1].manday}
            style={{width: '4rem'}}
          />
        </Table.Cell>
        <Table.Cell>
        <Droppable droppableId="GPS">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={{ backgroundColor: snapshot.isDraggingOver ? 'grey' : 'transparent', minHeight: "70px" }}
              {...provided.droppableProps}
            >
              {TechGPSByName.map((tech, index) => (
              <Draggable draggableId={tech.email+"+GPS"} index={index}>
                {(provided, snapshot) => (
                  <List>
              <List.Item>
              <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
               <Button as={Link} basic compact
                 to={`/hrmanagement/employees/${tech.email}`}
               >
               <Image avatar src={tech.photoUrl || "/assets/user.png"}/>
                <strong style={(tech.status === 'Employee') ? {color: 'green'} : {color: 'brown'}}>
                  {tech.name}{tech.preferredName !== "" ? `  (${tech.preferredName})` : ""}</strong>
              </Button>
              {(techinductionRegistry.get(tech.email) === 'N') ? 
              <Message negative size='mini' compact style={{padding: '0em 0.5em'}}>
                Not Inducted</Message> : ''}
                </div>
              </List.Item>
                     </List>
                )}
              </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        </Table.Cell>
        <Table.Cell>
        <Form>
          {/* <TextArea 
           rows={2}
           onChange={(e)=>handleInputChange(e, 1, "remark")}
           value={assignment[1].remark}
          /> */}
          <Form.Field
          control={TextareaAutosize}
          rows={1}
          onChange={(e: any)=>handleInputChange(e, 1, "remark")}
          value={assignment[1].remark}
        />
         </Form>
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell textAlign='center'><strong>AC</strong></Table.Cell>
        <Table.Cell textAlign='center'>
          <Input
            transparent
            onChange={(e, name)=>handleInputChange(e, 2, "manday")}
            type='number'
            value={assignment[2].manday}
            style={{width: '4rem'}}
          />
        </Table.Cell>
        <Table.Cell>
        <Droppable droppableId="AC">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={{ backgroundColor: snapshot.isDraggingOver ? 'grey' : 'transparent', minHeight: "70px" }}
              {...provided.droppableProps}
            >
              {TechACByName.map((tech, index) => (
              <Draggable draggableId={tech.email+"+AC"} index={index}>
                {(provided, snapshot) => (
                  <List>
              <List.Item>
              <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
               <Button as={Link} basic compact
                 to={`/hrmanagement/employees/${tech.email}`}
               >
               <Image avatar src={tech.photoUrl || "/assets/user.png"}/>
                <strong style={(tech.status === 'Employee') ? {color: 'green'} : {color: 'brown'}}>
                  {tech.name}{tech.preferredName !== "" ? `  (${tech.preferredName})` : ""}</strong>
              </Button>
              {(techinductionRegistry.get(tech.email) === 'N') ? 
              <Message negative size='mini' compact style={{padding: '0em 0.5em'}}>
                Not Inducted</Message> : ''}
                </div>
              </List.Item>             
                     </List>
                )}
              </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        </Table.Cell>
        <Table.Cell>
        <Form>
          {/* <TextArea 
           rows={2}
           onChange={(e)=>handleInputChange(e, 2, "remark")}
           value={assignment[2].remark}
          /> */}
          <Form.Field
          control={TextareaAutosize}
          rows={1}
          onChange={(e: any)=>handleInputChange(e, 2, "remark")}
          value={assignment[2].remark}
        />
         </Form>
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell textAlign='center'><strong>Total</strong></Table.Cell>
        <Table.Cell textAlign='center'>
          {total}
        </Table.Cell>
        <Table.Cell/>
        <Table.Cell/>
      </Table.Row>
    </Table.Body>
     </Table>
     </DragDropContext>
     <Segment clearing basic>
       <Button
          onClick={() => createMobileAssignment(project!.id, assignment)}
          floated="right"
          positive
          content={"Submit"}
        />
     </Segment>
    </Tab.Pane>
  );
};

export default observer(MobileAssignmentTab);
